import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Li = styled.li<any>`
  padding: 15px 0;
  border-top: 1px solid ${props => props.theme.palette.general.border};

  &:first-child {
    border: 0;
  }

  .product-data {
    display: flex;
  }

  .product-image {
    padding: 0;
    margin-right: 20px;

    > a {
      display: block;
      width: 60px;
      text-decoration: none;
      padding: 0;

      > div {
        width: 60px;
        height: 60px;
        background: no-repeat 50% 0 / contain;
      }
    }
  }

  .product-name {
    line-height: 1.3;
    font-size: ${props => props.isLivBrite ? '18px' : '15px'};
    color: ${props => props.theme.palette.general.headerColor};
    display: block;
    text-decoration: none;
  }

  .product-options {
    font: ${font('default', 'normal', '12px/1')};
    color: ${props => props.theme.palette.general.grey};
    margin: 5px 0 0;
    ${props => props.isLivBrite && `
      font-size: 16px;
    `}

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
    }

    li {
      font-size: ${props => props.isLivBrite ? '16px' : '14px'};

      span {
        color: ${props => props.isLivBrite ? props.theme.palette.general.greyDark : props.theme.palette.general.textColorLight};

        &.label {
          &::after {
            content: ": ";
          }
        }

        &.value {
          margin-left: 2px;
        }
      }
    }
  }

  .product-remove {
    margin-left: 10px;

    button {
      padding: 3px 0;
      width: auto;
      text-align: center;
      user-select: none;
      position: relative;
      display: block;
      color: ${props => props.theme.palette.general.textColor};
      font: ${font('default', 'normal', '15px/1')};
      border: none;
      background: none;
      outline: 0;
      box-sizing: border-box;
      cursor: pointer;
      transition: opacity 300ms ease;
      ${props => props.isLivBrite && `
        font-size: 18px;
      `}

      &[disabled] {
        cursor: default;
        opacity: 0.6;
      }

      span {
        margin-left: 10px;
        position: relative;
        top: -1px;
      }

      svg {
        width: 12px;
        height: auto;
        fill: ${props => props.theme.palette.general.textColor};
      }
    }
  }

  .product-subtotal {
    margin: 5px 0 0;
    font-weight: 600;
    font-size: ${props => props.isLivBrite ? '18px' : '16px'};
    color: ${props => props.theme.palette.general.textColor};

    small {
      font-size: 90%;
      font-weight: 400;
      color: ${props => props.theme.palette.general.textColor};
      margin: 0 5px 0 0;
    }
  }
`
